<template>
    <b-container>
        <b-table :items="users" :fields="fields" striped hover responsive>
            <template #cell(percentage)="data">
                <span :class="getPercentageClass(data.item.percentage)">
                    {{ data.item.percentage.toFixed(1) }}%
                </span>
            </template>
        </b-table>
    </b-container>
</template>

<script>
export default {
    name: 'UserList',
    props: {
        users: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            fields: [
                { key: 'name', label: 'Usuario' },
                { key: 'goal', label: 'Meta' },
                { key: 'calls', label: 'Visitas' },
                { key: 'percentage', label: 'Cumplimiento' },
            ],
        }
    },
    methods: {
        getPercentageClass(percentage) {
            if (percentage < 80) {
                return 'text-danger' // Rojo
            } else if (percentage >= 80 && percentage < 90) {
                return 'text-warning' // Amarillo
            } else {
                return 'text-success' // Verde
            }
        },
    },
}
</script>

<style scoped>
.text-danger {
    color: red;
}
.text-warning {
    color: orange;
}
.text-success {
    color: green;
}
</style>
